var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{
			'pb-50': _vm.isDesktop,
			'pb-100': !_vm.isDesktop
		}},[_c('span',{class:{
				'display-block font-weight-bold ellipsis': _vm.isDesktop,
				'display-flex align-items-center delta': !_vm.isDesktop
			}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),(_vm.investorSince)?_c('span',{staticClass:"muted eta",class:{
				'display-block': _vm.isDesktop,
				'display-flex': !_vm.isDesktop
			}},[_vm._v(" Investor since "+_vm._s(_vm.investorSince)+" ")]):_vm._e()]),(_vm.isMultipleEntities)?_c('span',{staticClass:"eta pb-25",class:{
			'display-block': _vm.isDesktop,
			'display-flex': !_vm.isDesktop
		}},[_vm._v(" Your accounts ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }